/** @module ProductSpec/SizeChart/SizeRangeController */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/_base/underscore",
	"csi/action/ActionView",
	"csi/action/Controller",
	"csi/comm/PostRequest",
	"csi/def",
	"csi/locale",
	"csi/service/nodeService",
	"csi/widget/MessageDialog",
	"csi/xml"

], function(declare,lang,_,ActionView,Controller,PostRequest,def,locale,{ resolveNodesWithDependencies },MessageDialog,xml) {
	const CSS_ATTR = "_CSS";

	/**
	 * This module is action controller for
	 * ProductSpec.xml
	 * Node = SizeChartRevision
	 * Heading Id="Group"
	 * View Widget = "ProductSpec/SizeChart/SizeRangeView"
	 * UI Path: Home/Styles/Style->Style/Specification/SizeChart->SizeChart/Properties -> "Size Range" tooltip "Edit"
	 */

	return declare(Controller, {

		/**
		 * @override
		 * Initialize the view
		 */
		getActionView(vr) {
			const node = this.getNode() || this.getParent();
			const defView = def.getNodeViewDef(node, "SizeRange");

			return new ActionView(this, defView, node);
		},

		/**
		 * @override
		 * Display a warning popup if the base size is changing when changing a size range
		 */
		async process() {
			// Submit the request when base size isn't changing or when the user clicks "Confirm" on the bypass warning dialog
			if (this.bypassConfirmed) {
				return Controller.prototype.process.call(this);  // nothing to do
			}
			
			// see if the base size is changing - is a bypass required
			const cache = this.getCache();
			const newSizeRangeUrl = this.popupView.newSizeRange;
			const sizeChart = this.getNode() || this.getParent();
			const oldSCSubSizeRange = cache.getNode(sizeChart.SizeChartSubSizeRanges[0]);
			const oldBaseSize = oldSCSubSizeRange.BaseSize;
			
			await resolveNodesWithDependencies([newSizeRangeUrl], ["Child:BaseSize"], cache); // pull nodes that would not be in the cache
			
			const newSizeRange = cache.getNode(newSizeRangeUrl);
			const newBaseSize = newSizeRange.BaseSize;
			const hasBypassedItem = sizeChart.SizeChartSubSizeRanges.length == 1 && 
									newSizeRange.Type === "SizeRangeType:Simple" &&
									oldBaseSize !== newBaseSize && 
									oldSCSubSizeRange.Sizes.indexOf(newBaseSize) == -1;
			
			if (!hasBypassedItem) {
				return Controller.prototype.process.call(this);  // nothing to do
			}

			// Prompt the user to send the request despite base size change
			new MessageDialog({
				buttons: [MessageDialog.BUTTON_CONFIRM + MessageDialog.BUTTON_PRIMARY, MessageDialog.BUTTON_CANCEL],
				materialIcon: MessageDialog.ICON_WARNING,
				message: locale.resource("SizeChartBaseSizeChangeWarning", [cache.getNode(oldBaseSize).$Name, cache.getNode(newBaseSize).$Name]),
				title: locale.resource("SizeChartBaseSizeChanging"),
				onResponse: (key, _) => {
					// Call the process method again to submit the request
					if (key == MessageDialog.BUTTON_CONFIRM) {
						this.bypassConfirmed = true;
						this.process();
					}
					// Close both the warning popup and form dialog
					else if (key == MessageDialog.BUTTON_CANCEL) {
						this.postProcess();
						this.closeDialog();
					}
				},
			}).show();

			return null;
		},
		
		/**
		 * @override
		 * Update server request
		 */
		toWriter() {

			const call = this.inherited(arguments); // csi/xml/CallMethod

			const {
				newSizeRange,
				changeIncrement,
				newIncrement,
				changeProductGroup,
				newProductGroup,
				maintainBaseSize,
				maintainTolerances,
				maintainDimensions,
				maintainIncrements
			} = this.popupView;

			call.addParameter("URL", xml.ATTR_REF, this.getNodeURL() || this.getParentURL());
			call.addParameter("SizeRange", xml.ATTR_REF, newSizeRange);
			call.addParameter("MaintainBaseSize", xml.ATTR_BOOLEAN, maintainBaseSize);
			call.addParameter("MaintainDimensions", xml.ATTR_BOOLEAN, maintainDimensions);
			if (changeIncrement){
				call.addParameter("Increment", xml.ATTR_REF, newIncrement)
				call.addParameter("MaintainIncrements", xml.ATTR_BOOLEAN, maintainIncrements);
			}
			if (changeProductGroup){
				call.addParameter("ProductGroup", xml.ATTR_REF, newProductGroup);
				call.addParameter("MaintainTolerances", xml.ATTR_BOOLEAN, maintainTolerances);
			}
// TODO: Design to decide how to handle Size Range for composite charts
			// Specify subrange for composite size chart
/*			if (this.getParent().SizeChartSubSizeRanges.length > 1){
				call.addParameter("SubRange", xml.ATTR_REF, this.getNodeURL());
			}*/
		}

	});
});